import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

const TabButtonsComponent = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(null); // Start with no tab active
    const navigate = useNavigate();

    // Toggle tab and update URL
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            if (tab === "1") {
                // For the first tab, navigate to /dashboard
                navigate(`/dashboard`);
            } else {
                // For other tabs, update the URL with the tab query parameter
                setSearchParams({ tab });
                navigate(`/trade?tab=${tab}`);
            }
        }
    };

    useEffect(() => {
        // Get the tab from the URL search params
        const tabFromUrl = searchParams.get('tab');

        // Set the active tab if it's valid (1, 2, or 3)
        if (tabFromUrl && ['1', '2', '3', '4', '5', '6'].includes(tabFromUrl)) {
            setActiveTab(tabFromUrl);
        } else {
            setActiveTab(null); // If the tab is invalid or not present, reset active tab
        }
    }, [searchParams]); // Watch searchParams for changes

    const layout = useSelector(state => state.Layout);
    const layoutMode = layout?.layoutModeType;
    const bgClass = layoutMode === 'dark' ? 'bg-black' : 'bg-white';

    return (
        <div id="mbl-v-bottom-tabs" className={`mobile-view-bottom-tabs mobile-bottom-tabs position-fixed w-100 start-0 end-0 px-2 ${bgClass}`}>
            <Nav pills className="nav-justified card-footer-tabs fs-17 pb-2">
                {/* <NavItem id="home">
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => toggleTab("1")}
                    >
                        <i style={{ fontSize: "28px" }} className="ri-home-line"></i>
                        <p style={{ fontSize: "10px" }} className="mobil-tabls-menu-title mb-0">Home</p>
                    </NavLink>
                </NavItem> */}
                <NavItem id="quotes">
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => toggleTab("2")}
                    >
                        <i style={{ fontSize: "28px" }} className="ri-arrow-up-down-line"></i>
                        <p style={{ fontSize: "10px" }} className="mobil-tabls-menu-title mb-0">Quotes</p>
                    </NavLink>
                </NavItem>
                <NavItem id="trading">
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => toggleTab("3")}
                    >
                        <i style={{ fontSize: "28px" }} className="ri-line-chart-fill"></i>
                        <p style={{ fontSize: "10px" }} className="mobil-tabls-menu-title mb-0">Trade</p>
                    </NavLink>
                </NavItem>
                <NavItem id="market-graph">
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "4" })}
                        onClick={() => toggleTab("4")}
                    >
                        <i style={{ fontSize: "28px" }} className="ri-bar-chart-fill"></i>
                        <p  style={{ fontSize: "10px" }}className="mobil-tabls-menu-title mb-0">Chart</p>
                    </NavLink>
                </NavItem>
                <NavItem id="history">
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "5" })}
                        onClick={() => toggleTab("5")}
                    >
                        <i style={{ fontSize: "28px" }} className="ri-history-line"></i>
                        <p  style={{ fontSize: "10px" }} className="mobil-tabls-menu-title mb-0">History</p>
                    </NavLink>
                </NavItem>
                <NavItem id="settings">
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "6" })}
                        onClick={() => toggleTab("6")}
                    >
                        <i style={{ fontSize: "28px" }} className="ri-settings-5-line"></i>
                        <p style={{ fontSize: "10px" }} className="mobil-tabls-menu-title mb-0">Setting</p>
                    </NavLink>
                </NavItem>
            </Nav>
        </div>
    );
};

export default TabButtonsComponent;
